<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm02a">
<a id="page02">
<br/><br/>
<p class="paraNoIndent1">With Valentine’s Day coming up, it’s the perfect opportunity to indulge in some romance, and where better than with eight new fantastic Harlequin Presents<sup>®</sup> stories!</p>
<p class="paraNoIndent1">This month we have bestselling author Lynne Graham with the second book in her PREGNANT BRIDES trilogy, <em class="italic">Ruthless Magnate, Convenient Wife.</em> Get whisked away to the stunning Moscow where ruthless billionaire Sergei Antonovich will stop at nothing to make the shy and virginal Alissa his convenient wife!</p>
<p class="paraNoIndent1">And please help us celebrate Carole Mortimer’s 150th book, <em class="italic">The Infamous Italian’s Secret Baby.</em> When one night leads to one baby, Bella Scott finds herself at the mercy of infamous Gabriel Danti!</p>
<p class="paraNoIndent1">Why not treat yourself with a wonderful story of blackmail in Robyn Donald’s <em class="italic">The Rich Man’s Blackmailed Mistress.</em> And Talos Xenakis’s plans for revenge change when he discovers his mistress is pregnant in Jennie Lucas’s <em class="italic">Bought: The Greek’s Baby.</em></p>
<p class="paraNoIndent1">Out this month is our first book in the BRIDE ON APPROVAL miniseries. Whether bought, sold, bargained for or bartered, these brides have no choice but to say I do. Be sure not to miss Caitlin Crews’s debut book, <em class="italic">Pure Princess, Bartered Bride.</em></p>
<p class="paraNoIndent1">Who will reunite the two Stefani diamonds, and become ruler? Find out in the last installment of THE ROYAL HOUSE OF KAREDES, <em class="italic">The Desert King’s Housekeeper Bride</em> by Carol Marinelli. But the saga continues in April with DARK-HEARTED DESERT MEN. Four brooding sheikhs with a hint of Karedes in them.</p>
<p class="paraNoIndent1">And last, but by no means least, don’t forget about any of our fabulous new miniseries coming out in 2010. The glamour, the excitement, the intensity just keep getting better.</p>
<p class="paraNoIndent1">Wow! 2010—this truly is the year of Presents! <em class="italic">Your everyday luxury.</em></p>
</a></div>
<a id="page02">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// boughtthegreeksbaby_fm02a.vue?10515008